(function () {
  'use strict';

  function initShowcaseRow(root) {
    var viewport = root.querySelector('[data-showcase-viewport]');
    var track = root.querySelector('[data-showcase-track]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-showcase-card]'));
    var prevBtn = root.querySelector('[data-showcase-prev]');
    var nextBtn = root.querySelector('[data-showcase-next]');
    var dotsWrap = root.querySelector('[data-showcase-dots]');

    var isCarousel = root.dataset.layout === 'carousel' || root.dataset.mobileSwipe === 'true';
    var dragEnabled = root.dataset.drag === 'true';
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseFloat(root.dataset.autoplaySpeed || '5') * 1000;

    /* ---------- Arrow navigation ---------- */
    function cardStep() {
      var first = cards[0];
      if (!first) return 0;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    /* ---------- Dots ---------- */
    if (dotsWrap && cards.length) {
      var visiblePerView = Math.max(1, Math.round(track.clientWidth / (cardStep() || 1)));
      var dotCount = Math.max(1, Math.ceil(cards.length / visiblePerView));
      for (var d = 0; d < dotCount; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (d + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            track.scrollTo({ left: index * visiblePerView * cardStep(), behavior: 'smooth' });
          });
        })(d);
        dotsWrap.appendChild(dot);
      }
      var dotEls = Array.prototype.slice.call(dotsWrap.children);
      function updateDots() {
        var active = Math.round(track.scrollLeft / (visiblePerView * cardStep() || 1));
        dotEls.forEach(function (el, i) {
          el.classList.toggle('is-active', i === active);
        });
      }
      track.addEventListener('scroll', debounce(updateDots, 60));
      updateDots();
    }

    track.addEventListener('scroll', debounce(updateArrowState, 60));
    updateArrowState();

    /* ---------- Mouse drag (desktop) ---------- */
    if (isCarousel && dragEnabled) {
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles this
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      window.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });

      function endDrag() {
        isDown = false;
        track.classList.remove('is-dragging');
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      // Prevent link clicks from firing right after a drag
      track.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    /* ---------- Autoplay ---------- */
    if (isCarousel && autoplayEnabled && cards.length > 1) {
      var timer = null;
      function tick() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      }
      function start() { timer = setInterval(tick, autoplaySpeed); }
      function stop() { clearInterval(timer); }
      start();
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }

    /* ---------- Scroll-in reveal animation ---------- */
    if (root.dataset.animate === 'true' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      cards.forEach(function (card) { io.observe(card); });
    } else {
      cards.forEach(function (card) { card.classList.add('is-visible'); });
    }

    /* ---------- Wishlist heart (client-side only) ---------- */
    var STORAGE_KEY = 'showcase-row-wishlist';
    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    }
    function saveWishlist(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
      catch (e) { /* storage unavailable — fail silently */ }
    }
    var wishlist = getWishlist();
    var heartButtons = root.querySelectorAll('[data-showcase-wishlist]');
    heartButtons.forEach(function (btn) {
      var key = btn.dataset.key;
      if (wishlist.indexOf(key) > -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = wishlist.indexOf(key);
        if (idx > -1) {
          wishlist.splice(idx, 1);
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          wishlist.push(key);
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }
        saveWishlist(wishlist);
      });
    });

    window.addEventListener('resize', debounce(updateArrowState, 150));
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-showcase-row]').forEach(initShowcaseRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/edited live in the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    var row = e.target.querySelector('[data-showcase-row]');
    if (row) initShowcaseRow(row);
  });
})();
